import { useContext } from 'react';
import styled from 'styled-components';

import cancelSVG from '~images/cancel.svg';
import { DialogContext } from './Dialog';
import { primaryColor } from '~theme';

const ModalTitle = ({ title, noClose = false }) => {
  const { close } = useContext(DialogContext);

  return (
    <Header>
      <TitleText>{title}</TitleText>
      {!noClose ? <CloseIcon src={cancelSVG} onClick={close} /> : null}
    </Header>
  );
};

const Header = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;
`;

const TitleText = styled.h2`
  font-size: 28px;
  margin: unset;
  font-weight: 400;
  line-height: 1.5;
  color: ${primaryColor};
`;

const CloseIcon = styled.img`
  align-self: center;
  cursor: pointer;
  height: 34px;
`;

export default ModalTitle;
